if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productInfo = document.getElementById(`MainProduct-${this.sectionId}`);

        // Main ATC button from snippets/buy-buttons.liquid
        this.target =
          document.getElementById(`ProductSubmitButton-${this.sectionId}`) ||
          this.productInfo?.querySelector('product-form');

        if (!this.target) return;

        this.button = this.querySelector('[data-sticky-atc-button]');
        this.onClick = this.scrollToForm.bind(this);
        this.button.addEventListener('click', this.onClick);

        // Show only after the main button has been scrolled past (it is above the viewport)
        this.observer = new IntersectionObserver(([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.toggle(scrolledPast);
        });
        this.observer.observe(this.target);

        // ---- Price sync ----
        this.priceEl = this.querySelector('[data-sticky-atc-price]');
        if (!this.priceEl) return;

        // 1) "Purchase Options" radios (1 Pair / 2 Pairs) — they only change quantity,
        //    so the price is taken from the checked option's label
        this.onPurchaseChange = (event) => {
          if (event.target.matches('input[name="PurchaseOptions"]')) this.syncPrice();
        };
        document.addEventListener('change', this.onPurchaseChange);

        // 2) Fallback for products without purchase options:
        //    Dawn re-renders #price-{sectionId} when a variant with a different price is selected
        this.mainPrice = document.getElementById(`price-${this.sectionId}`);
        if (this.mainPrice) {
          this.priceObserver = new MutationObserver(() => this.syncPrice());
          this.priceObserver.observe(this.mainPrice, {
            childList: true,
            subtree: true,
            characterData: true,
          });
        }

        // Initial sync (the browser may restore a checked radio after reload)
        this.syncPrice();
      }

      getPurchaseOptionPrice() {
        const checked = document.querySelector('input[name="PurchaseOptions"]:checked');
        return checked?.closest('label')?.querySelector('.price')?.textContent.trim();
      }

      getMainPrice() {
        const price = this.mainPrice?.querySelector('.price');
        if (!price) return;

        const onSale = price.classList.contains('price--on-sale');
        const current = price.querySelector(
          onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular'
        );
        return current?.textContent.trim();
      }

      syncPrice() {
        const text = this.getPurchaseOptionPrice() || this.getMainPrice();
        if (text) this.priceEl.textContent = text;
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.priceObserver?.disconnect();
        this.button?.removeEventListener('click', this.onClick);
        if (this.onPurchaseChange) document.removeEventListener('change', this.onPurchaseChange);
        document.body.classList.remove('sticky-atc-visible');
      }

      toggle(show) {
        this.classList.toggle('is-visible', show);
        this.toggleAttribute('inert', !show);
        this.setAttribute('aria-hidden', String(!show));
        document.body.classList.toggle('sticky-atc-visible', show);
      }

      scrollToForm() {
        // Scroll to the size picker if present, so the user can choose a size right away
        const destination =
          this.productInfo?.querySelector('variant-selects') || this.target;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        destination.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'center',
        });
      }
    }
  );
}
